import { useContext, useMemo } from 'react'
import GlobalContext from '../context/GlobalContext'
import { Country } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'

type ReturnProps = {
    loaded: boolean
    countries: Country[]
    getCountry: (alpha2: string) => Country
    getCountryName: (id: string) => string
}

export default function useCountries(): ReturnProps {
    const { i18n } = useTranslation()

    const { countries } = useContext(GlobalContext)
    const loaded = useMemo<boolean>(() => countries.length > 0, [countries])

    const getCountry = (alpha2: string) => (countries || []).find(value => value.alpha2 === alpha2)
    const getCountryName = (id: string) =>
        getI18NName(
            (countries || []).find(value => value.alpha2 === id),
            i18n.language,
        )

    return { loaded, countries, getCountry, getCountryName }
}
